<div class="breadcrumbs-wrapper">
    <fa-icon [icon]="faMapMarker"></fa-icon>
    <ng-container>
        <mpro-tag  (tagClick)="breadcrumbSelected()" [color]="!breadcrumbs?.size ? 'blue' : 'gray'">
            The World
        </mpro-tag>
    </ng-container>
    <ng-container *ngFor="let breadcrumb of breadcrumbs | keyvalue: originalOrder, let last = last, let first = first">
        <fa-icon *ngIf="first" [icon]="faChevronRight"></fa-icon>
        <mpro-tag  (tagClick)="!last && breadcrumbSelected(breadcrumb)" [color]="last ? 'blue' : 'gray'">
            {{ breadcrumb?.value?.name }}
        </mpro-tag>
        <fa-icon *ngIf="!last" [icon]="faChevronRight"></fa-icon>
    </ng-container>
</div>